/**
 * Registry for the "always available" actions tier on the dashboard Actions section --
 * self-service entry points a shareholder can start any time, distinct from
 * ASSIGNABLE_TASK_TYPES (helpers/task-assignments.js), which requires an admin to assign
 * the task first and carries a due date.
 *
 * Only static metadata lives here (key, label, url). State-dependent copy -- e.g. whether
 * a beneficiary designation already exists, and the resulting "Add Now" vs "Manage" label --
 * is computed per-call by the caller, since there's no generic way to check "has the user
 * completed X" across action types without a plugin system this single consumer doesn't
 * warrant yet.
 */

/**
 * @typedef {{ key: string; label: string; url: string }} AlwaysAvailableAction
 */

/** @type {Array<AlwaysAvailableAction>} */
export const ALWAYS_AVAILABLE_ACTIONS = [
	{
		key: 'beneficiary_designation',
		label: 'Beneficiary Designation',
		url: '/beneficiaries/',
	},
	{
		key: 'transfer_request',
		label: 'Request a Transfer',
	},
	{
		key: 'redemption',
		label: 'Request Redemption/Buy Back',
	},
	// One card per active on-request collection (collection-campaign-v1); label is the collection's title.
	{
		key: 'collection_enroll',
		label: 'Respond to a Request',
	},
];

/**
 * @param {string} key
 * @returns {AlwaysAvailableAction | undefined}
 */
export function getAlwaysAvailableAction(key) {
	return ALWAYS_AVAILABLE_ACTIONS.find((a) => a.key === key);
}
